// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__1r5ln","title":"style_title__2MvGp","time":"style_time__1icmw","content":"style_content__1MoOB"};